import dayjs from "dayjs";
const DateFormatUtils = {
    // transform date to yyyy-mm-dd format
    YYYYMMDD(date: Date): string {
        return dayjs(date).format('YYYY-MM-DD');
    },
    YYYYMMDD_HHmm(date: Date): string {
        return dayjs(date).format('YYYY-MM-DD, HH:mm');
    },
    MMDD(date: Date): string {
        return dayjs(date).format('MM-DD');
    },
    DAY(date: Date): string {
        return dayjs(date).format('D');
    },
    DAY_MONTH_SHORT(date: Date): string {
        return dayjs(date).format('D MMM');
    },
    DAY_MONTH(date: Date): string {
        return dayjs(date).format('D MMMM');
    },
    MONTH(date: Date): string {
        return dayjs(date).format('MMMM');
    },
    MONTH_SHORT(date: Date): string {
        return dayjs(date).format('MMM');
    },
    MONTH_YEAR(date: Date): string {
        return dayjs(date).format('MMMM YYYY');
    },
    YEAR(date: Date): string {
        return dayjs(date).format('YYYY');
    },
    HHmm(date: Date): string {
        return dayjs(date).format('HH:mm');
    },
    dateFromDayTime(date: string, time: string): Date {
        let day = dayjs(date, 'YYYY-MM-DD');
        let times = dayjs(time, 'HH:mm:ss');
        let computed = day.hour(times.hour()).minute(times.minute()).second(times.second()).toDate();
        return computed;
    }
}

export default DateFormatUtils;